import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static links(postId) {
        return PostApiBase.links({
            post_id: postId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }
}
